import React from "react";
import { CurvedArrow } from "../../../../../styles/img/svg/CurvedArrow";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";
import { GoalAchievedMessage } from "./GoalAchievedMessage";

export const GoalsProgressBar = (props) => {

    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid" >
                    <UiCol lg="12">
                        <UiCardTitle title={props.title} />
                        <div className="sb-goals-progress-bar">

                            {
                                props.gainedPoints == props.totalPoints ?
                                    (
                                        <>
                                            <div className="sb-goals-progress-bar__achieved sb-completely-achieved" style={{ width: '100%' }}>
                                                <h4>Goal Achieved  / {props.totalPoints} Points</h4>
                                            </div>                                          
                                        </>
                                    )
                                    :
                                    (
                                        <>
                                            <div className="sb-goals-progress-bar__achieved" style={{ width: props.progress + '%',marginBottom:'4rem' }}>
                                                <h4>{props.gainedPoints} Points / {props.totalPoints} Points</h4>
                                            </div>
                                            {
                                                props.progress < 89 ?
                                                    <div className="sb-goals-progress-bar__earned-info" style={{ left: props.progress + '%' }} >
                                                        <CurvedArrow />
                                                        <p>You are here with:
                                                            {props.gainedPoints} Points</p>
                                                    </div>
                                                    :

                                                    <div className="sb-goals-progress-bar__earned-info sb-mt-89" >
                                                        <p>You are here with:
                                                            {props.gainedPoints} Points</p>
                                                    </div>
                                            }
                                        </>
                                    )
                            }

                        </div>

                        {
                             props.gainedPoints == props.totalPoints && <GoalAchievedMessage />
                        }
                    </UiCol>
                </UiRowContainer>
            </UiContentWr >
        </>
    )
}